import { render } from "./OverlayView.vue?vue&type=template&id=a3553820"
import script from "./OverlayView.vue?vue&type=script&lang=js"
export * from "./OverlayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__